module.exports = __webpack_public_path__ + "./Michael_dd6018d45164577d13f26d6d47a64f49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Michael.jpg
// module id = 570
// module chunks = 0